module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/virgina-tech-3739e9402cbca6287c727ee0aa653bed.svg";